// extracted by mini-css-extract-plugin
export default {"wrapper":"e_-z"};